import { render, staticRenderFns } from "./ChangeUserType.vue?vue&type=template&id=501f4009&scoped=true"
import script from "./ChangeUserType.vue?vue&type=script&lang=js"
export * from "./ChangeUserType.vue?vue&type=script&lang=js"
import style0 from "./ChangeUserType.vue?vue&type=style&index=0&id=501f4009&prod&lang=scss"
import style1 from "./ChangeUserType.vue?vue&type=style&index=1&id=501f4009&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501f4009",
  null
  
)

export default component.exports